import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=7d705c0b&scoped=true&"
import script from "./Watermark.vue?vue&type=script&lang=js&"
export * from "./Watermark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d705c0b",
  null
  
)

export default component.exports